// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2RPyV","location":"Header_location__2K8v_"};